export default "https://cdn-static.gokick.com/assets/6e728f413af15b4cc1be7e84aa96f9132e166160/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";